import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-modal-popup',
  templateUrl: './modal-popup.component.html',
  styleUrls: ['./modal-popup.component.css']
})
export class ModalPopupComponent implements OnInit {
    @Input() modalDetails: any;
    @Input() width;
    @Input() height;
    @Input() footer = 'true';
    @Output() onChange: EventEmitter<any> = new EventEmitter();
    
    constructor() { }

    ngOnInit(): void {
    }

    closeModal(value) {
        this.onChange.emit(value);
    }
   
}
